exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nimg[data-v-a0d66860] {\n    width: 100%;\n    margin: auto;\n    display: block;\n    margin-bottom: 10px;\n}\n", ""]);

// exports
